import React from 'react'
import { Image as RNImage, ImageProps as RNImageProps } from 'react-native'

// Minimal expo-image API surface used by the app, mapped onto RN-Web Image.
// `cachePolicy`, `placeholder`, `transition` are accepted and ignored on web
// (the browser HTTP cache already handles caching). `contentFit` maps to
// RN's resizeMode.
type ExpoImageProps = Omit<RNImageProps, 'resizeMode'> & {
  cachePolicy?: string
  placeholder?: unknown
  transition?: number | object
  contentFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down'
}

export const Image = ({
  cachePolicy: _cachePolicy,
  placeholder: _placeholder,
  transition: _transition,
  contentFit,
  ...props
}: ExpoImageProps) => {
  const resizeMode =
    contentFit === 'contain' ? 'contain' : contentFit === 'fill' ? 'stretch' : 'cover'
  return <RNImage {...props} resizeMode={resizeMode} />
}

export default { Image }
